import axios from "axios";
import parseErrors from "../../modules/parse-errors";

const toggleDealActive = (commercialDeal, token) => {
  return axios
    .post(
      `${window.API}/commercial-deals/${commercialDeal}/toggle-active`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .catch(error => {
      return parseErrors(error);
    });
};

const removeFile = (commercialDeal, token) => {
  return axios
    .post(
      `${window.API}/commercial-deals/${commercialDeal}/remove-file`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .catch(error => {
      return parseErrors(error);
    });
};


const checkVenuesForCommercialDeals = async (venues, token) => {
  try {
    const response = await axios.post(
      `${window.API}/commercial-deals/venues-has-commercial-deals/`,
      {venues: venues},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {}
};

export { toggleDealActive, removeFile, checkVenuesForCommercialDeals };
